import React, { useEffect, useState } from "react"
import { Table, Modal, Button } from "antd"
import { maintainOrderMateriallLog } from "@/service/ordersService"
export default (props) => {
    const { logData, setLogData } = props
    const [list, setList] = useState([])

    const [pagination, setpagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
    })

    useEffect(() => {
        getDetail()
    }, [logData]) // eslint-disable-line react-hooks/exhaustive-deps

    //获取订单日志
    const getDetail = (pageNum = 1) => {
        maintainOrderMateriallLog({
            pageNum: pageNum,
            pageSize: 10,
            searchItem: {
                id: logData.id,
            },
        }).then((res) => {
            setList(res.retData.list)
            setpagination({
                current: pageNum,
                total: res.retData.total,
                pageSize: 10,
            })
        })
    }


    const columns = [
        {
            title: "工单编号",
            align: "center",
            dataIndex: "orderCode",
        },
        {
            title: "客户名称",
            align: "center",
            dataIndex: "customerName",
        },
        {
            title: "车辆牌照",
            align: "center",
            dataIndex: "vehicleCode",
        },
        {
            title: "使用数量",
            align: "center",
            dataIndex: "num",
        },
        {
            title: "登记日期",
            align: "center",
            dataIndex: "createTime",
        },
    ]

    const handleClose = () => {
        setLogData({
            visible: false,
            id: "",
        })
    }

    return (
        <>
            <Modal
                forceRender
                visible={logData.visible}
                title="维修工单用料记录"
                onCancel={handleClose}
                centered={true}
                footer={[
                    <Button key="link" onClick={handleClose}>
                        关闭
                    </Button>,
                ]}
                width={1200}
            >
                <Table
                    rowKey={(record) => `${record.orderId}-${record.id}`}
                    dataSource={list}
                    pagination={{
                        showQuickJumper: true,
                        showSizeChanger: false,
                        showTotal: () => `共${pagination.total}条`,
                        position: ["bottomCenter"],
                        ...pagination,
                        onChange: getDetail,
                    }}
                    columns={columns}
                    size="small"
                />
            </Modal>
        </>
    )
}
